module.exports = __webpack_public_path__ + "static/media/bg-icon-small.c31b9bd9.png";